import { Pipe, PipeTransform } from '@angular/core';
import { RequirementStatusDto } from 'src/app/shared/models/job-unit-requirements.model';

@Pipe({
    name: 'translateExperience',
    standalone: true
})
export class TranslateExperiencePipe implements PipeTransform {
    transform(experience: RequirementStatusDto): string {
        return !experience || experience.isNoneOrNull || experience.isNA ? null : experience.value.replace(/^is/i, '');
    }
}
